export default __webpack_public_path__ + "assets/images/0521fa4699dbf93d6698058813705fc2.png";